<app-base-modal
  [title]="createTestingResultModalTitle"
>
  <form
    class="create-component-form"
    [formGroup]="testingResultForm"
  >
    @for (field of createTestingResultFormFields; track $index) {
      <mat-form-field appearance="outline">
        <mat-label>{{ field.label }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="7"
            cdkAutosizeMaxRows="7"
            placeholder="Введите комментарий"
            [formControlName]="field.fieldName"
          ></textarea>
      </mat-form-field>
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      type="button"
      class="save-button"
      [disabled]="testingResultForm.invalid"
      (click)="handleCreate()"
    >
      Создать
    </button>
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Отмена
    </button>
  </div>
</app-base-modal>
